"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSink = exports.getEffectTasks = exports.invokeEffect = exports.invokeTrigger = exports.createStore = exports.SinkFactory = void 0;
const SinkContainer_1 = require("./SinkContainer");
const __sinkFactory__ = new SinkContainer_1.SinkContainer();
/**
 * default sink container for create store and bind sinks
 */
exports.SinkFactory = __sinkFactory__;
/**
 * Create store by sink configuration
 * @param {SinkConfiguration} config
 */
exports.createStore = __sinkFactory__.createStore.bind(__sinkFactory__);
/**
 * invoke triggers by action
 * @param action sink action
 */
exports.invokeTrigger = __sinkFactory__.invokeTrigger.bind(__sinkFactory__);
/**
 * invoke effect by action
 * @param action sink action
 */
exports.invokeEffect = __sinkFactory__.invokeEffect.bind(__sinkFactory__);
/**
 * Get traced effect tasks
 * @returns {[Promise]} promise array
 */
exports.getEffectTasks = __sinkFactory__.getEffectTasks.bind(__sinkFactory__);
/**
 * Get sink instance by sink class
 * @param sink Sink class
 * @returns Sink instance
 */
exports.getSink = __sinkFactory__.getSink.bind(__sinkFactory__);
